import { Navigate, useLocation, useNavigate } from "react-router-dom";
import PermissionDeniedDialog from "../components/shared/dialogs/PermissionDeniedDialog";
import React, { useEffect } from "react";
import { isTokenExpires } from "../services/interceptor";
import { decryptPermissions } from "../utils/permissionsHelpers";

const Unauthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const accessToken = localStorage.getItem("token");
  const permissions = decryptPermissions();

  useEffect(() => {
    if (!accessToken || permissions?.length === 0) {
      navigate("/login");
    } else if (location.pathname === "/") {
      if (
        !!accessToken ||
        !isTokenExpires(accessToken) ||
        permissions.length > 0
      ) {
        // if (permissions.some(permission => permission.code.toLowerCase().includes("dashboard"))) {
        //     navigate("/dashboard")
        // } else {
        //     navigate(`/${permissions[0].path}`)
        // }

        navigate("/dashboard");
      }
    }
  }, []);

  return <PermissionDeniedDialog isOpen={false} />;
};
export default Unauthorized;
